const ADD_CFOP = "ADD_CFOP";
const UPDATE_CFOP = "UPDATE_CFOP";
const GET_ALL_CFOP = "GET_ALL_CFOP";
const DESTROY_CFOP = "DESTROY_CFOP";

module.exports = {
    ADD_CFOP,
    UPDATE_CFOP,
    GET_ALL_CFOP,
    DESTROY_CFOP,
}
